import React, { useState, useEffect } from "react";
import { LOCALE } from "../../properties/Locale";
import { changePageTitle } from "../../common/actions/CommonActions";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../assets/jss/layouts/appStyle";
import { useDispatch } from "react-redux";
import moment from "moment";
import FormBuilderModeler from "./FormBuilderModeler";
import { FormBuilderRepository } from "./FornBuilderRepository";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
  IconButton,
  Link,
  Icon,
  Button,
} from "@material-ui/core";
import Card from "../../common/components/Card/Card.js";
import CardHeader from "../../common/components/Card/CardHeader.js";
import CardBody from "../../common/components/Card/CardBody.js";
import FormBuilderPreview from "./FormBuilderPreview";

const useStyles = makeStyles(styles);

export default function FormBuilderComponent(props) {
  const classes = useStyles();

  const dispatch = useDispatch();
  const [customForm, setCustomForm] = React.useState();
  const [formData, setFormData] = React.useState({
    Email: "sashe.angelovski@aucta.dev",
    Municipalitie: "4c76f354-4c3d-4e5d-b53f-dd683569907f",
    Name: "Sashe",
    School: "5472b285-33ac-47af-ad4c-5c5213f5e578",
    Surname: "Angelovski",
    Telephone: "070323839",
    attachments: {},
  });
  const [allCustomForms, setAllCustomForms] = React.useState();
  const [step, setStep] = React.useState(0);

  React.useEffect(() => {
    FormBuilderRepository.findAll().then(
      (res) => {
        setAllCustomForms(res.data);
      },
      (err) => {}
    );
    dispatch(changePageTitle(LOCALE.formbuilder));
  }, []);

  const editCustomForm = (item) => {
    setCustomForm(item);
    setStep(1);
  };

  const viewCustomForm = (item) => {
    setCustomForm(item);
    setStep(2);
  };

  const deleteCustomForm = (item) => {
    FormBuilderRepository.delete(item);
  };
  const changeStep = (step) => {
    setStep(step);
  };

  return (
    <div>
      {step == 0 && (
        <div>
          <Card>
            <CardHeader color="theme">
              <Tooltip
                title={LOCALE.formbuilder_new_form}
                aria-label={LOCALE.formbuilder_new_form}
                arrow
                placement={"bottom"}
              >
                <Link style={{ textDecoration: "none" }}>
                  <Button
                    color="primary"
                    variant="contained"
                    startIcon={<Icon>add_circle_outline</Icon>}
                    size="small"
                    aria-label="create"
                    onClick={() => changeStep(3)}
                  >
                    {LOCALE.formbuilder_new_form}
                  </Button>
                </Link>
              </Tooltip>
            </CardHeader>
            <CardBody>
              <Table aria-label="groups table" className={classes.table}>
                <TableHead>
                  <TableRow className={classes.tableHeadRow}>
                    <TableCell
                      className={
                        classes.tableCell + " " + classes.tableHeadCell
                      }
                    >
                      {LOCALE.name}
                    </TableCell>
                    <TableCell
                      className={
                        classes.tableCell + " " + classes.tableHeadCell
                      }
                    >
                      {LOCALE.details}
                    </TableCell>
                    <TableCell
                      className={
                        classes.tableCell + " " + classes.tableHeadCell
                      }
                    >
                      {LOCALE.date_created}
                    </TableCell>
                    <TableCell
                      style={{ marginBottom: "62px", minWidth: "80px" }}
                    >
                      {LOCALE.actions}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {allCustomForms &&
                    allCustomForms.map((customForm, index) => (
                      <TableRow
                        key={customForm.id}
                        className={classes.tableBodyRow}
                        style={index % 2 ? { background: "#f0f0f0" } : {}}
                      >
                        <TableCell className={classes.tableCell}>
                          {customForm.name}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {customForm.description}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {moment(customForm.dateCreated).format(
                            "YYYY-MM-DD HH:mm:ss"
                          )}{" "}
                          ({moment(customForm.dateCreated).fromNow()})
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          <Tooltip
                            title={LOCALE.details}
                            aria-label={LOCALE.details}
                          >
                            <Link style={{ textDecoration: "none" }}>
                              <IconButton
                                size="small"
                                color="primary"
                                aria-label="details"
                                onClick={() => viewCustomForm(customForm)}
                              >
                                <Icon>ballot</Icon>
                              </IconButton>
                            </Link>
                          </Tooltip>
                          <Tooltip title={LOCALE.edit} aria-label={LOCALE.edit}>
                            <Link style={{ textDecoration: "none" }}>
                              <IconButton
                                size="small"
                                style={{ color: "orange" }}
                                aria-label="edit"
                                onClick={() => editCustomForm(customForm)}
                              >
                                <Icon>edit</Icon>
                              </IconButton>
                            </Link>
                          </Tooltip>
                          <Tooltip
                            title={LOCALE.delete}
                            aria-label={LOCALE.delete}
                          >
                            <Link style={{ textDecoration: "none" }}>
                              <IconButton
                                color="secondary"
                                size="small"
                                aria-label="delete"
                                onClick={() => deleteCustomForm(customForm)}
                              >
                                <Icon>delete</Icon>
                              </IconButton>
                            </Link>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </CardBody>
          </Card>
        </div>
      )}
      {step == 1 && (
        <div>
          <IconButton
            style={{
              color: "black",
            }}
            onClick={() => setStep(0)}
          >
            <Icon>arrow_back_ios</Icon>
          </IconButton>{" "}
          <FormBuilderModeler {...customForm}></FormBuilderModeler>
        </div>
      )}
      {step == 2 && (
        <div>
          <IconButton
            style={{
              color: "black",
            }}
            onClick={() => setStep(0)}
          >
            <Icon>arrow_back_ios</Icon>
          </IconButton>{" "}
          <FormBuilderPreview {...customForm}></FormBuilderPreview>
        </div>
      )}
      {step == 3 && (
        <div>
          <IconButton
            style={{
              color: "black",
            }}
            onClick={() => setStep(0)}
          >
            <Icon>arrow_back_ios</Icon>
          </IconButton>{" "}
          <FormBuilderModeler></FormBuilderModeler>
        </div>
      )}
    </div>
  );
}
